const config = {
  rowSelection: false,
  columns: [
    {
      title: '退款申请单号',
      dataIndex: 'billNo',
      // render: "IdRender",
      ellipsis: true,
      width: 180,
    },
    {
      title: '订单号',
      dataIndex: 'orderNo',
      width: 180,
      ellipsis: true,
    },
    {
      title: '退款类型',
      dataIndex: 'refundTypeName',
      width: 120
    },
    {
      title: '申请时间',
      dataIndex: 'applyTime',
      itemType: 'dateTime',
      width: 160,
    },
    {
      title: '签单日期',
      dataIndex: 'signDate',
      itemType: 'dateTime',
      width: 160
    },
    {
      title: '开工日期',
      dataIndex: 'actualStartDate',
      itemType: 'dateTime',
      width: 160
    },
    {
      title: '完工日期',
      dataIndex: 'actualEndDate',
      itemType: 'dateTime',
      width: 160
    },
    {
      title: '退款金额',
      dataIndex: 'refundAmount',
      width: 120,
    },
    {
      title: '支付方式',
      dataIndex: 'payTypeName',
      width: 120,
    },
    {
      title: '是否原路退回',
      dataIndex: 'backTrackFlagName',
      width: 150
    },
    {
      title: '退款状态',
      dataIndex: 'refundStateName',
      width: 120
    },
    {
      title: '退款支付状态',
      dataIndex: 'payStateName',
      width: 150
    },
    {
      title: '支付异常原因',
      dataIndex: 'payException',
      ellipsis: true,
      width: 200
    },
  ],
  search: [
    {
      name: 'contractNo',
      label: '合同号',
    },
    {
      name: 'orderNo',
      label: '订单号',
    },
    {
      name: 'customerPhone',
      label: '客户电话',
    },
    {
      name: 'customerName',
      label: '客户名称',
    },
    {
      name: 'billNo',
      label: '退款申请单号',
    },
    {
      name: 'applyTime',
      label: '退款申请日期',
      itemType: 'autoDate',
      allowClear: 'true'
    },
    {
      name: 'refundStateList',
      label: '退款状态',
      itemType: 'select',
      data: 'refundStatusList',
      labelKey: 'description',
      key: 'key',
    },
    {
      name: 'refundTypeList',
      label: '退款类型',
      itemType: 'select',
      data: 'refundTypeList',
      labelKey: 'name',
      key: 'priKey',
    }
  ],
  footer: []
}
export default config
